import { usePlatform } from "@/hooks/usePlatform";

/**
 * Task #7622 — the customer support email for BAC is now a single constant:
 * support@bookaclassic.com (routed into Intercom). The former flag-based
 * switch (feature_support_email_team) and resolveSupportEmail() have been
 * removed. Non-BAC brands (DriveShare) keep their platform-configured
 * support email (support@driveshare.com) unchanged.
 */
export function useSupportEmail(): string {
  const platform = usePlatform();
  if (platform.platform !== "bac") return platform.supportEmail;
  return "support@bookaclassic.com";
}
